export const TRANSLATIONS_RU = {
    call:"Позвонить",
    send:"Оправить",
    rating:"Ваша оценка",
    yourComment:"Ваш комментарий",
    thanksForReview:"Благодарим за оставленный отзыв!",
    thanksForCall:"Спасибо что воспользовались нашим сервисом!",
    yourName:"Ваше имя..",
    yourPhone:"Ваш телефон..",
    serverError:"Ой! Внутренняя ошибка сервера",
    headPhoneError:"Подключите наушники с микрофоном и перезагрузите страницу",
    notAllowedError:"Ваш браузер запрещает доступ к вашему микрофону",
    missLink:'Данная ссылка не найдена.',
    inactiveLink:'Данная ссылка не активна.',
    notSupported:'Ваш браузер не поддерживает WebRTC',
};